import request from "@/utils/request";

// TODO 获取当前用户信息
export const getUserInfo = () => {
    return request.get("/user/get");
}

// 获取用户列表
export const getUserPage = (params) => {
    // return request.get("/user/list", { params });
    return request.get("/user/page", { params });
}
export const getAllUser = () => {
    return request.get("/user/list", {  });
}

// TODO 创建用户
export const createUser = (data) => {
    return request.post("/user/create", data);
}

// TODO 更新用户信息
export const updateUser = (id, data) => {
    return request.put(`/user/update/${id}`, data);
}

// 删除用户
export const deleteUser = (id) => {
    return request.delete(`/user/${id}`);
}

// 重置用户密码
export const resetUserPassword = (id,password) => {
    return request.put(`/user/reset/${id}`, {password});
}

// TODO 批量删除用户
export const batchDeleteUsers = (ids) => {
    return request.post("/user/batch-delete", { ids });
}

// 更新用户状态
export const updateUserStatus = (id, status) => {
    return request.put(`/user/status/${id}`, { status });
}

// TODO 检查用户名是否存在
export const checkUsername = (username) => {
    return request.get(`/user/check-username`, { params: { username } });
}

// TODO 检查邮箱是否存在
export const checkEmail = (email) => {
    return request.get(`/user/check-email`, { params: { email } });
}

// TODO 检查手机号是否存在
export const checkPhone = (phone) => {
    return request.get(`/user/check-phone`, { params: { phone } });
}
// 小程序设备解绑
export const deleteMiniAppDeviceNumber = (id) => {
    return request.delete(`/user/device/${id}`);
}